import React from "react";
import Creatable from "react-select/lib/Creatable";
import Select,{components} from "react-select";
import { withStyles } from "@material-ui/core";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Clear from "@material-ui/icons/CancelOutlined";
import { isEqual } from "lodash/lang";

const style = theme => ({
    Dropdown:{
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor,
        maxWidth:300
    },
    reactSelect:{
        '& .select__control':{
            minWidth: 130,
            backgroundColor: "transparent",
            minHeight: 24,
            maxHeight: "max-content",
            boxSizing:"border-box",
            borderRadius: 2,
            marginTop:6,
            border: `1px solid ${theme.iconColor}`,
            fontSize: 12,
            cursor: "pointer",
            '&:hover,&.select__control--is-focused':{
                boxShadow: "none",
                borderRadius: 2,
                border: `1px solid ${theme.iconColor}`,
            },
            '& .select__value-container':{
                height: 22,
                color: theme.TextColor,
                padding:"0px 8px",
                '& .select__input':{
                    height:22,
                    color: theme.TextColor,
                    '&>input':{
                        height:22
                    }
                },
                '&>div':{
                    margin:0,
                    padding:0
                },
            },
            '& .select__single-value':{
                color: "inherit"
            },
            '& .select__indicators':{
                height: 22,
                '& .select__indicator':{
                    padding: 5,
                    height: 24,
                },
                '& .select__indicator-separator':{
                    height: 24,
                    margin: 0,
                    display: "none"
                }
            },
            '& .select__value-container--is-multi':{
                paddingTop:0,
                paddingBottom:0,
                '&.select__value-container':{
                    height: "max-content",
                    '& .select__multi-value':{
                        backgroundColor: theme.AppBGColor,
                        color: theme.TextColor,
                        margin:"2px",
                        '& .select__multi-value__label':{
                            color: theme.TextColor,
                        }
                    },
                }
            }
        },
        '& .select__menu':{
            margin: 0,
            maxHeight: 140,
            borderRadius: 2,
            border: `1px solid ${theme.iconColor}`,
            '& .select__menu-list': {
                maxHeight: 138,
                borderRadius: 2,
                fontSize:12,
                backgroundColor: theme.ModalBGColor,
                color: theme.TextColor,
            },
            '& .select__option--is-focused':{
                backgroundColor: theme.HighlightColor,
                cursor: "pointer",
            },
            '& .select__option--is-selected':{
                backgroundColor: theme.HeaderSelectedText
            }
        }
    },

    iconStyle:{
        color: theme.iconColor,
        cursor: "pointer"
    }
})

class SelectComponent extends React.Component{
    constructor(props){
        super(props);
        this.canAcceptNewValue = false;
        this.options = [];
        this.state = {
            value: { label: this.props.value?.toString() || null, value: null},
            inputValue:""
        }
    }

    componentDidMount(){
        this.updateSelectOptions();
    }

    componentDidUpdate(prevProps){
        if(prevProps.column.colDef.field != this.props.column.colDef.field || !isEqual(this.props.data,prevProps.data)){
            this.updateSelectOptions();
        } else if( this.props.value !== prevProps.value){
            this.updateSelectedValue();
        }
    }

    updateSelectedValue = () =>{
       const value = this.options.find(option => option.label === this.props.value || option.value === this.props.value);
       this.setState({
            value: value || null
        }, this.updateParent);
    }

    updateSelectOptions = () => {
        const { colDef } = this.props.column || {};
        if(colDef){
            this.canAcceptNewValue = colDef.cellEditorParams && colDef.cellEditorParams.canAcceptNewValue;
            const { isMultiSelection , noNullValue } = colDef.cellEditorParams || {};
            if(noNullValue){
                this.options = this.props.data.filter(option => option.value !== null);
            } else{
                this.options = this.props.data;
            }

            let value = null;
            if(isMultiSelection){
                const labels = this.props.value && this.props.value.split(",").map(value => value.trim());
                value = labels ? this.options.filter(option => labels.includes(option.label.trim())) : null;
            } else{
                const selectedValue = this.state.value  ||  { label: this.props.value || null, value: null};
                value = this.options.find((option) =>
                  [option.label?.toString(), option.value?.toString()].includes(
                    selectedValue.label?.toString()
                  )
                );
            }

            this.setState({
                value: value || null
            }, this.updateParent)
        }
    }

    getValue = () => {
        return this.state.value ? this.state.value.label : "";
    }

    handleChange = (value) => {
        if(this.props.isMultiSelection){
            value = value && value.length ? value :null;
            this.setState({
                value
            }, this.updateParent)

        } else {
            if(value){
                this.setState({
                    value:{
                        ...value,
                        label: value.label,
                        value: value.value,
                        isNewValue: Boolean(value.__isNew__)
                    }
                },this.updateParent);
            } else {
                this.setState({
                    value
                }, this.updateParent)
            }
        }

    }

    onInputChange = (value) => {
        const { colDef } = this.props.column || {};
        if(colDef && colDef.cellEditorParams && colDef.cellEditorParams.capitalize){
            this.setState({
                inputValue : value ? value.toUpperCase() : value
            });
        } else{
            this.setState({
                inputValue : value
            });
        }
    }

    updateParent(){
        if(this.props.onChange){
            this.props.onChange(this.state.value)
        }
    }

    filterOption = (option, filterValue) => {
        const searchParamsList = [option.label, option?.value, option.data?.labelSuffix]
        return searchParamsList.some((params) =>
          params
            ?.toString()
            .toUpperCase()
            .includes(filterValue.toString().toUpperCase())
        );
    }

    isValidNewOption = (inputValue, selectValue, selectOptions) => {
        const { colDef } = this.props.column || {};
        const format = colDef && colDef.cellEditorParams && colDef.cellEditorParams.format || /./;
        return inputValue && selectOptions.findIndex(option => option.label === inputValue) < 0 &&  format && format.test(inputValue);
    }

    noOptionsMessage = () =>{
        if(this.canAcceptNewValue){
            const { colDef } = this.props.column || {};
            const headerName = colDef.headerName || "option";
            const placeholder = colDef.cellEditorParams && colDef.cellEditorParams.placeholder || "";
            return `${placeholder}`;
        }
        return "No options"
    }

    render(){
        if(this.props.reactContainer){
            this.props.reactContainer.className = this.props.classes.Dropdown;
        }
        const { classes, customReactSelectClass=null } = this.props;
        const Dropdown = this.canAcceptNewValue ? Creatable : Select;
        const { colDef } = this.props.column || {};
        const isClearable = colDef.cellEditorParams ? (colDef.cellEditorParams.isClearable === undefined ? true : colDef.cellEditorParams.isClearable): true;
        return (
            <Dropdown
                placeholder={this.props.placeholder ?? "Select..."}
                autoFocus={this.props.autoFocus ?? true}
                isMulti={this.props.isMultiSelection}
                ref={this.props.inputRef}
                isClearable={isClearable}
                value={this.state.value}
                inputValue={this.state.inputValue}
                onInputChange={this.onInputChange}
                onChange={this.handleChange}
                options={ this.options}
                classNamePrefix={"select"}
                className={`${classes.reactSelect} ${customReactSelectClass}`}
                menuPlacement="auto"
                filterOption={this.filterOption}
                isValidNewOption={this.isValidNewOption}
                closeMenuOnSelect={!this.props.isMultiSelection}
                noOptionsMessage={this.noOptionsMessage}
                openMenuOnFocus={this.props?.openMenuOnFocus ?? false}
                components = {{
                    DropdownIndicator: props => <ArrowDropDown {...props.innerProps} className={classes.iconStyle} />,
                    ClearIndicator :props => <Clear {...props.innerProps} className={classes.iconStyle} />,
                    Option: props =>  <components.Option {...props}>
                                            <div>{props.data.label} {props.data.labelSuffix}</div>
                                        </components.Option>
                }}
            />
        )
    }
}

export default withStyles(style)(SelectComponent);